module.exports = __webpack_public_path__ + "static/media/plygon.d09cbc2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plygon.svg
// module id = 2249
// module chunks = 0